<template>
  <el-dialog
    title="鉴定单数据范围设置"
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <div class="custom-transfer-wrap">
      <el-transfer
        v-if="visible"
        ref="transfer"
        v-model="info.roomIds"
        v-loading="loading"
        filterable
        filter-placeholder="请输入鉴定中心名称"
        :titles="['未启用', '已启用']"
        :data="list"></el-transfer>
    </div>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Staffroom from '@/service/staffroom'
import Appraise from '@/service/appraise'
export default {
  name: 'AiModelRoomModal',
  data() {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 200 },
      list: [],
      info: { staffId: null, staffName: '', roomIds: [] }
    }
  },
  methods: {
    handleClosed() {
      this.info = { ...this.info, ...this.$options.data().info }
    },
    handleSubmit() {
      this.loading = true
      Staffroom.setstaffrooms({ ...this.info })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if (result === 0) {
            this.$message.success('设置成功')
            this.visible = false
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetchList() {
      this.loading = true
      Appraise.getappraisalrooms({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if (result === 0) {
            this.list = records.map(item => ({ key: item.id, label: item.roomName }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options = {}) {
      this.info = { ...this.info, ...options }
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.custom-transfer-wrap {
  /deep/.el-transfer-panel {
    width: 260px;
  }
  /deep/.el-transfer-panel__body {
    height: 320px;
  }
}
</style>
